import { keysToSnakeCase, keysToCamelCase } from '@wix/wix-vod-shared/common';
import { PrivateWidgets } from '@wix/wix-vod-api-site-based/privateWidgets';
import { toError } from '../../parsers/to-error';
export class PrivateWidgetsService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.updateWidgetSettings = (widgetId, settings) => this.privateWidgetsService
            .updateSettings(widgetId, keysToSnakeCase(settings))
            .then((response) => keysToCamelCase(response.data))
            .catch(toError);
        this.updateWidget = (widgetId, widgetMetadata) => this.privateWidgetsService
            .create(widgetId, keysToSnakeCase(widgetMetadata))
            .then((response) => keysToCamelCase(response.data))
            .catch(toError);
        this.privateWidgetsService = new PrivateWidgets(httpClient);
    }
}
//# sourceMappingURL=widgets.js.map